function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React, { Children, cloneElement, Component } from 'react';
import { reduce, isEmpty } from 'lodash';
import SaveAddButton from "./save-add-button";
import CancelAddButton from "./cancel-add-button";
export var makeFormName = function makeFormName(name) {
  return "add-new-".concat(name);
};

var mapFormFieldsToValues = function mapFormFieldsToValues(form) {
  return reduce(form, function (result, _ref) {
    var name = _ref.name,
        value = _ref.value;
    return _objectSpread({}, result, _defineProperty({}, name, value));
  }, {});
};

var mapInputIdToValue = function mapInputIdToValue(inputId) {
  var element = document.getElementById(inputId);
  return _defineProperty({}, element.name, element.value);
};

var createChildrenWithFormAttribute = function createChildrenWithFormAttribute(children, formName) {
  return Children.map(children, function (child) {
    return cloneElement(child, {
      children: child.props.children ? createChildrenWithFormAttribute(child.props.children, formName) : child.props.children,
      form: formName
    });
  });
};

var AddNewBox =
/*#__PURE__*/
function (_Component) {
  _inherits(AddNewBox, _Component);

  function AddNewBox() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, AddNewBox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AddNewBox)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      valid: false
    });

    _defineProperty(_assertThisInitialized(_this), "formName", makeFormName(_this.props.name));

    _defineProperty(_assertThisInitialized(_this), "fields", createChildrenWithFormAttribute(_this.props.fields, _this.formName));

    _defineProperty(_assertThisInitialized(_this), "handleCancelClick", function (event) {
      var onCancel = _this.props.onCancel;
      event.preventDefault();
      onCancel();
    });

    _defineProperty(_assertThisInitialized(_this), "handleSaveClick", function (event) {
      var onSave = _this.props.onSave;
      var formFieldValues = mapFormFieldsToValues(_this.form);
      var fieldValues = isEmpty(formFieldValues) ? mapInputIdToValue(_this.props.inputId) : formFieldValues;
      event.preventDefault();
      onSave(fieldValues);
    });

    _defineProperty(_assertThisInitialized(_this), "handleFormChange", function () {
      _this.setState({
        valid: _this.form.checkValidity()
      });
    });

    return _this;
  }

  _createClass(AddNewBox, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.createdForm = document.createElement('form');
      this.createdForm.id = this.formName;
      document.body.appendChild(this.createdForm);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var createdForm = this.createdForm;
      document.body.removeChild(createdForm);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          saveButtonText = _this$props.saveButtonText,
          cancelButtonText = _this$props.cancelButtonText;
      var valid = this.state.valid;
      var fields = this.fields;
      return React.createElement("article", {
        className: "SelectInputWithAddNew-new-box",
        onChange: this.handleFormChange
      }, fields, React.createElement("div", {
        className: "SelectInputWithAddNew-button-wrapper"
      }, React.createElement(CancelAddButton, {
        onClick: this.handleCancelClick,
        text: cancelButtonText
      }), React.createElement(SaveAddButton, {
        disabled: !valid,
        text: saveButtonText,
        onClick: this.handleSaveClick
      })));
    }
  }, {
    key: "form",
    get: function get() {
      return document.forms[this.formName];
    }
  }]);

  return AddNewBox;
}(Component);

_defineProperty(AddNewBox, "propTypes", {
  saveButtonText: PropTypes.string.isRequired,
  cancelButtonText: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  fields: PropTypes.node.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  inputId: PropTypes.string
});

export { AddNewBox as default };